<template>
<div id="storiesTop">

    <div >
        <div class="text-center mt-2">
    
    <v-btn icon v-if="circleNotice" @click="checkNotifications()"><v-icon color='red'>mdi-bell-alert</v-icon></v-btn>
    </div>

    </div>


  <StoryList v-if="user !== undefined || user !== null"  :userID="user.UserID" :key="resetPage" @memoriesChanged="resetPage=!resetPage"/>

</div>
</template>
<script>

// import TodaysQC from '@/components/TodaysQC.vue';
import StoryList from '@/components/StoryList.vue';
import EventService from '@/services/EventService.js'; 


export default {
  name: 'home',
  components: {
    //  TodaysQC,
     StoryList
  },
 data() {
    return {
      circleNotice: false, 
      resetPage: false,
       predefinedBtnProps: {
          xs: {
            'x-small': true
          },
          sm: {
            'small': true
          },
          md: {
            
          },
          lg: {
            'large': true
          },
          xl: {
            'x-large': true
          }
        }
    };
  },
  mounted() {
    this.myOpenInvitations() 
  },

computed: {
  user(){
    return this.$store.state.user
  },

  loginState(){
    return this.$store.state.loginState
  },

            btnProps()  {
          let props = {}
          switch(this.$vuetify.breakpoint.name) {
            case 'xs':
              props.color = 'blue'
              props['x-small'] = true
              break
            case 'sm':
              props.color = 'blue'
              props['small'] = true
              break  
            case 'lg':
              props.color = 'green'
              props['large'] = true
              break
             case 'xl':
              props.color = 'purple'
              props['x-large'] = true
              break 
            default: 
              props.color = 'red'
          }
          return props
        }
        
  },
  
methods: {
      async myOpenInvitations() {
      await EventService.myOpenInvitations(this.user.UserID)
      .then(
        (rinvitations => {
          if(rinvitations.length !== 0) {
            this.circleNotice = true
          }
        })
      )
      .then (
        this.$nextTick(()=>{})
      );
    },

    async checkNotifications() {
          this.$router.push('Circles')
    }



}

}

</script>
<style lang="scss" scoped>
.container {
  width: 75vw;
}
 
</style>